import credit from './credit-card.svg'
import plus from './plus.svg'
import more from './more.svg'
import edit from './edit.svg'
import approve from './approved.svg'
import logo from './logo.jpg'
import globe from './globe.svg'
import user from './user.svg'
import garbage from './garbage.svg'
import play from './play-button.svg'
import search from './searchIcon_right.png'
import refresh from './refreshIcon.png'
import list from './list.png'
import menuWhite from './menu-white.png'
import sortWhite from './sort-arrows-white.png'
import sortUp from './sort-up.png'
import sortDown from './sort-down.png'
import cavronDown from './cavron-down.png'
import israelFlag from './israel_flag.png'
import britishFlag from './english_flag.svg'

export const hebrew = israelFlag
export const english = britishFlag
export const creditCardIcon = credit
export const plusIcon = plus
export const moreIcon = more
export const editIcon = edit
export const approveIcon = approve
export const markidimLogo = logo
export const GLOBE = globe
export const userIcon = user
export const deleteIcon = garbage
export const DANCELIST = play
export const searchIcon = search
export const refreshIcon = refresh
export const listIcon = list
export const menuIcon = menuWhite
export const sortArrows = sortWhite
export const sortUpArrow = sortUp
export const sortDownArrow = sortDown
export const cavronDownIcon = cavronDown
